import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SignalApi } from 'client/voladeum/signal/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_OBJECT } from '../../constants';

const initialState: SignalApi = EMPTY_OBJECT;

export const signalSlice = createSlice({
  name: SLICE.SIGNAL,
  initialState,
  reducers: {
    setSignal: (_state, action: PayloadAction<SignalApi>) => {
      return action.payload;
    },
    updateSignal: (state, action: PayloadAction<SignalApi>) => {
      return { ...state, ...action.payload };
    },
    clearSignal: () => {
      return initialState;
    },
  },
});

export const { setSignal, updateSignal, clearSignal } = signalSlice.actions;

export default signalSlice.reducer;
